'use strict';
const _ = require('lodash');


// Toggle Permission action
function toggleMobileMenu() {
  return {
    type: 'MOBILE_MENU_TOGGLE',
  };
}


export {
  toggleMobileMenu,
};



// WEBPACK FOOTER //
// ./client/src/actions/header.js